import gql from 'graphql-tag';



export const add = gql`mutation CreateCommodity($commodity: CommodityInput!) {
    createCommodity(commodity: $commodity) {
        id
        name
        riskFactor
        isArchived
        commodityGroup {
            id
            name
        }
    }
}`;

export const edit = gql`mutation EditCommodity($id: ID!, $commodity: CommodityInput!) {
    editCommodity(id: $id, commodity: $commodity) {
        id
        name
        riskFactor
        isArchived
        commodityGroup {
            id
            name
        }
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/commodity.js